<template>
    <div>
        <div>
            <table class="table_">
                <col width="50%"/>
                <col width="50%"/>
                <tr>
                    <td>地理涵盖范围</td><td>中国大陆/大中华/全球除美/全球</td>
                </tr>
                <tr>
                    <td>地理涵盖范围以外地区紧急医疗</td><td>不包含（可选包含）</td>
                </tr>
                <tr>
                    <td>年度最高保额</td><td>500,000（可选升级）</td>
                </tr>
                    <tr>
                    <td>个人年免赔额</td><td>0元</td>
                </tr>
                    <tr>
                    <td>保险自付比例</td><td>0%</td>
                </tr>
                <tr>
                    <td>医院涵盖范围</td><td>公立医院（普通，特需，国际部）（可选升级）</td>
                </tr>
                <tr>
                    <td>昂贵医院自付比例</td><td>100%（可选升级）</td>
                </tr>
                <tr>
                    <td>直付服务</td><td>有</td>
                </tr>
            </table>
        </div>
        <div class="plan_section_">
            <div class="header_">
                <span>必选保障：一般住院治疗</span>
                <span @click="planDesc[0].unexpand = !planDesc[0].unexpand" 
                    class="h_right_">
                    {{planDesc[0].unexpand ? '展开' : '收起'}}
                    <a-icon :type="planDesc[0].unexpand ? 'down' : 'up'">
                    </a-icon>
                </span>
            </div>
            <div v-if="!planDesc[0].unexpand" class="content_">
                <table class="table_">
                    <col width="50%" />
                    <col width="50%" />
                    <tr><td>等待期</td><td>30天（意外情况除外）/0天 （需提交在保证明）</td></tr>
                    <tr><td>重症监护病房费</td><td>全额赔付</td></tr>
                    <tr><td>手术室费和急诊室费</td><td>全额赔付</td></tr>
                    <tr><td>住院食宿费</td><td>全额赔付（可选）</td></tr>
                    <tr><td>陪床费</td><td>全额赔付</td></tr>
                    <tr><td>医师诊疗费、手术医师费和麻醉师费</td><td>全额赔付</td></tr>
                    <tr><td>护理费</td><td>全额赔付</td></tr>
                    <tr><td>治疗费</td><td>全额赔付</td></tr>
                    <tr><td>检查费</td><td>全额赔付</td></tr>
                    <tr><td>住院药品费和手术敷料费</td><td>全额赔付</td></tr>
                    <tr><td>矫形改造手术费</td><td>全额赔付</td></tr>
                    <tr><td>耐用医疗设备费</td><td>全额赔付</td></tr>
                    <tr><td>精神和心理疾病</td><td>全额赔付（可选）</td></tr>
                    <tr><td>临终关怀（最高涵盖45天）</td><td>全额赔付（可选）</td></tr>
                    <tr><td>康复治疗和专业护理费（累计以90天为上限）</td><td>全额赔付（可选）</td></tr>
                    <tr><td>无理赔住院现金补贴</td><td>全额赔付（可选）</td></tr>
                    <!-- <tr><td>赴异地就医的交通费补贴</td><td>全额赔付（可选）</td></tr> -->
                </table>
            </div>
        </div>
        <div class="plan_section_">
            <div class="header_">
                <span>可选：门诊计划</span>
                <span @click="planDesc[1].unexpand = !planDesc[1].unexpand" 
                    class="h_right_">
                    {{planDesc[1].unexpand ? '展开' : '收起'}}
                    <a-icon :type="planDesc[1].unexpand ? 'down' : 'up'">
                    </a-icon>
                </span>
            </div>
            <div v-if="!planDesc[1].unexpand" class="content_">
                <table class="table_">
                    <col width="50%">
                    <col width="50%">
                    <tr><td>门诊累计年限额</td><td>20,000/30,000/40,000/50,000/全额赔付</td></tr>
                    <tr><td>医师诊疗费和专家门诊费</td><td>全额赔付（可选）</td></tr>
                    <tr><td>处方药费</td><td>全额赔付（90天为限）</td></tr>

                    <tr><td>化验费和检查费</td><td>全额赔付</td></tr>
                    <tr><td>理疗费(包括物理治疗、脊柱指压治疗、职业病恢复指导和语言障碍治疗等)</td><td>全额赔付（可选）</td></tr>
                    <tr><td>中医针灸疗法和顺势疗法</td><td>全额赔付（可选）</td></tr>
                    <tr><td>中医治疗</td><td>全额赔付（可选）</td></tr>
                    <tr><td>急诊室费</td><td>全额赔付</td></tr>
                    <tr><td>耐用医疗设备费</td><td>全额赔付</td></tr>
                    <tr><td>精神疾病</td><td>全额赔付（可选）</td></tr>
                    <tr><td>临终关怀</td><td>全额赔付（可选）</td></tr>
                    <tr><td>家庭护理费</td><td>全额赔付（可选）</td></tr>
                    <tr><td>紧急牙科治疗</td><td>全额赔付（可选）</td></tr>
                    <tr><td>睡眠检查和治疗费</td><td>全额赔付（可选）</td></tr>
                    <tr><td colspan="2" style="text-align:center">特殊治疗（受限于门诊和住院上限）</td></tr>
                    <tr><td>既往症</td><td>全面医学核保/承担一般既往症，除外重大既往症</td></tr>
                    <tr><td>门诊手术费</td><td>全额赔付</td></tr>
                    <tr><td>慢性病</td><td>若非既往症则全额赔付</td></tr>
                    <tr><td>重大疾病</td><td>若非既往症则全额赔付</td></tr>
                    <tr><td>先天性疾病/出生疾病</td><td>全额赔付（可选）</td></tr>
                    <tr><td>非既往症的艾滋病</td><td>全额赔付（可选）</td></tr>
                </table>
            </div>
        </div>
        <div  class="plan_section_">
            <div class="header_">
                <span>可选：紧急救援保障</span>
                <span @click="planDesc[2].unexpand = !planDesc[2].unexpand" 
                    class="h_right_">
                    {{planDesc[2].unexpand ? '展开' : '收起'}}
                    <a-icon :type="planDesc[3].unexpand ? 'down' : 'up'">
                    </a-icon>
                </span>
            </div>
            <div v-if="!planDesc[2].unexpand" class="content_">
                <table class="table_">
                    <col width="50%">
                    <col width="50%">
                    <tr><td>救护车</td><td>全额赔付</td></tr>
                    <tr><td>紧急医疗转运</td><td>全额赔付</td></tr>
                    <tr><td>住宿费</td><td>每日限额800，上限12天</td></tr>
                    <tr><td>遗体遣返和就地安葬</td><td>160,000</td></tr>
                </table>
            </div>
        </div>
        <div  class="plan_section_">
            <div class="header_">
                <span>可选：体检保障</span>
                <span @click="planDesc[3].unexpand = !planDesc[3].unexpand" 
                    class="h_right_">
                    {{planDesc[3].unexpand ? '展开' : '收起'}}
                    <a-icon :type="planDesc[3].unexpand ? 'down' : 'up'">
                    </a-icon>
                </span>
            </div>
            <div v-if="!planDesc[3].unexpand" class="content_">
                <table class="table_">
                    <col width="50%">
                    <col width="50%">
                    <tr><td>体检保障</td><td>3,200/5,000/不附加</td></tr>
                </table>
            </div>
        </div>
        <div  class="plan_section_">
            <div class="header_">
                <span>可选：齿科保障</span>
                <span @click="planDesc[4].unexpand = !planDesc[4].unexpand" 
                    class="h_right_">
                    {{planDesc[4].unexpand ? '展开' : '收起'}}
                    <a-icon :type="planDesc[4].unexpand ? 'down' : 'up'">
                    </a-icon>
                </span>
            </div>
            <div v-if="!planDesc[4].unexpand" class="content_">
                <table class="table_">
                    <col width="50%">
                    <col width="50%">
                    <tr><td>包括预防，基础，重大治疗</td><td>2,000/5,000/10,000/不附加</td></tr>
                    <tr><td>预防治疗</td><td>全额赔付</td></tr>
                    <tr><td>基础治疗</td><td>赔付比例80%</td></tr>
                    <tr><td>重大治疗</td><td>赔付比例50%</td></tr>
                </table>
            </div>
        </div>
        <div  class="plan_section_">
            <div class="header_">
                <span>可选：孕产保障 </span>
                <span @click="planDesc[5].unexpand = !planDesc[5].unexpand" 
                    class="h_right_">
                    {{planDesc[5].unexpand ? '展开' : '收起'}}
                    <a-icon :type="planDesc[5].unexpand ? 'down' : 'up'">
                    </a-icon>
                </span>
            </div>
            <div v-if="!planDesc[5].unexpand" class="content_">
                <table class="table_">
                    <col width="50%">
                    <col width="50%">
                    <tr><td>顺产，剖腹产，孕产并发症，新生儿护理</td><td>30,000/60,000/不附加</td></tr>
                </table>
            </div>
        </div>
        <div  class="plan_section_">
            <div class="header_">
                <span>可选：眼科保障 </span>
                <span @click="planDesc[6].unexpand = !planDesc[6].unexpand" 
                    class="h_right_">
                    {{planDesc[6].unexpand ? '展开' : '收起'}}
                    <a-icon :type="planDesc[6].unexpand ? 'down' : 'up'">
                    </a-icon>
                </span>
            </div>
            <div v-if="!planDesc[6].unexpand" class="content_">
                <table class="table_">
                    <col width="50%">
                    <col width="50%">
                    <tr><td>眼科检查、配镜</td><td>1,000/2,400/不附加</td></tr>
                </table>
            </div>
        </div>
        <!-- <div  class="plan_section_">
            <div class="header_">
                <span>可选：特定筛查福利 </span>
                <span @click="planDesc[7].unexpand = !planDesc[7].unexpand" 
                    class="h_right_">
                    {{planDesc[7].unexpand ? '展开' : '收起'}}
                    <a-icon :type="planDesc[7].unexpand ? 'down' : 'up'">
                    </a-icon>
                </span>
            </div>
            <div v-if="!planDesc[7].unexpand" class="content_">
                <table class="table_">
                    <col width="50%">
                    <col width="50%">
                    <tr><td>宫颈涂片筛查和常规乳腺钼靶，每年一次（45岁以上女性筛查）</td><td>全额赔付（可选）</td></tr>
                    <tr><td>前列腺特异抗原筛查，每年一次（45岁以上男性筛查）</td><td>全额赔付（可选）</td></tr>
                    <tr><td>家族病史筛查</td><td>最高限额2,000元（可选）</td></tr>
                    <tr><td>1周岁内的入保婴儿常规检查</td><td>累计以6次为限（可选）</td></tr>
                    <tr><td>0-7周岁内的入保儿童疫苗注射</td><td>全额赔付（可选）</td></tr>
                </table>
            </div>
        </div> -->
    </div>
</template>
<style lang="scss" scoped>
    .table_ {
        border-color: #eee;
        border: 1px solid #eee;
        width: 100%;
        table-layout: fixed;
        .center_ {
            text-align: center;
        }
        td {
            border: 1px solid #eee;
            &:nth-child(2n+1) {
                color: #333;
                font-weight: bold;
                padding-left: 12px;
            }
            &:nth-child(2n) {
                text-align: center;
            }
        }
    }
    .plan_section_ {
        margin: 12px 0;
        color: #6e6e6e;
        border-radius: 16px;
        box-shadow: 0rem 0rem 6px 0rem rgba(96, 130, 253, 0.47);
        overflow: hidden;

        .header_ {
            line-height: 30px;
            display: flex;
            justify-content: space-between;
            background: linear-gradient(to bottom, #92a9fc 0%, #6284fe 100%);
            font-size: 14px;
            padding: 12px;
            color: #fff;
            .h_right_ {
                font-size: 12px;
            }
        }
        .pre_ {
            white-space: pre-wrap;
        }
        .content_ {
            margin: 12px;
            font-size: 12px;
        }
        .flex_row_ {
            display: flex;
            align-items: center;
        }
        .place_ {
            visibility: hidden;
        }
        .lh37_ {
            line-height: 36px;
        }
        .left_ {
            border-right: 1px solid #eee;
            border-bottom: 1px solid #eee;
            padding-left: 6px;
            color: #333;
            font-weight: bold;
        }
        .right_ {
            text-align: center;
            border-right: 1px solid #eee;
            border-bottom: 1px solid #eee;
        }
        .line_h_ {
            line-height: 50px;
        }
    }
</style>
<script>
export default {
    props: {
        edit: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            planDesc: [
                { unexpand: false },
                { unexpand: false },
                { unexpand: true },
                { unexpand: true },
                { unexpand: true },
                { unexpand: true },
                { unexpand: true },
                { unexpand: true }
            ]
        }
    }
}
</script>